import { render } from "./SSOFab.vue?vue&type=template&id=4b588738"
import script from "./SSOFab.vue?vue&type=script&lang=js"
export * from "./SSOFab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__